/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CatalogEntryBulkPatchRequest } from '../../models/catalog-entry-bulk-patch-request';
import { Error } from '../../models/error';

export interface PatchCatalogEntriesBulk$Params {
  'Active-Tenant-Identifier': string;
      body: CatalogEntryBulkPatchRequest
}

export function patchCatalogEntriesBulk(http: HttpClient, rootUrl: string, params: PatchCatalogEntriesBulk$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'successResult'?: Array<string>;
'errors'?: Array<Error>;
}>> {
  const rb = new RequestBuilder(rootUrl, patchCatalogEntriesBulk.PATH, 'patch');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'successResult'?: Array<string>;
      'errors'?: Array<Error>;
      }>;
    })
  );
}

patchCatalogEntriesBulk.PATH = '/catalog-entries/bulk-update';
